import { useQuery } from '@tanstack/react-query';
import { ctcApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';
import { CtcQueryOverrides } from 'src/api/queries/ctc/ctcSnapshotOptions';

const STATUS_STALE_TIME = 60_000;

/** @registry Accounting period / integration status shown on the CTC pages. */
export function useCtcCurrentMonthStatus(overrides?: CtcQueryOverrides) {
  return useQuery({
    queryKey: queryKeys.ctc.currentMonthStatus(),
    queryFn: ({ signal }) =>
      ctcApiClient.getCurrentMonthDetails(toCancelToken(signal)),
    staleTime: STATUS_STALE_TIME,
    ...overrides,
    meta: { errorContext: 'CTC current month status' },
  });
}
